import {defineStore} from 'pinia'
import api from '@/stores/api'
import {useFilterStore} from './filter'
import {ref, reactive} from 'vue'
import i18n from "@/plugins/i18n/i18n";

export const useProductsStore = defineStore('products', () => {

    const products = ref([])
    const filteredProducts = ref([])
    const modelVariants = reactive([])
    const paginatedModels = ref([])
    const totalModels = ref(0)
    const modelCounts = ref(0)
    const currentPage = ref(1)
    const perPage = ref(8)

    async function loadModelsFromApi() {
        const params = {}
        if (window.app.model_list.product) {
            params['product[equals]'] = window.app.model_list.product
        }
        try {
            await api.get('/model/', {params})
                .then(response => {
                    products.value = response.data
                })
        } catch (error) {
            // eslint-disable-next-line
            console.error('Error loading products:', error)
        }
        updateModelList()
        useFilterStore().loadFilterFromApi()
    }

    function updateModelList() {
        // load all model variants based on product.variants  into modelVariants
        products.value.forEach((product) => {
            const attributesToDisplay = []
            const mappedVariants = Object.entries(product.variants).map(([, variant]) => {
                Object.values(variant.attributes)
                    .filter(attribute => attribute.type.displayedInListing)
                    .forEach(variantAttribute => {
                        if (!Object.values(attributesToDisplay).some(value => value.title === variantAttribute.type.title)) {
                            attributesToDisplay.push({ title: variantAttribute.type.title, type: 'text', values: [] })
                        }
                        const key = Object.values(attributesToDisplay).findIndex(value => value.title === variantAttribute.type.title)
                        if (!attributesToDisplay[key].values.some(value => value.uid === variantAttribute.uid)) {
                            attributesToDisplay[key].values.push(structuredClone(variantAttribute))
                        }
                        if (variantAttribute.icon) {
                            attributesToDisplay[key].type = 'icons'
                        }
                    })
                return {
                    title: variant.title,
                    uid: variant.uid,
                    id: variant.id,
                    attributes: structuredClone(Object.values(variant.attributes)),
                    group: product.product.group,
                }
            })
            const mappedProduct = {
                title: product.title,
                uid: product.uid,
                group: product.product.group,
                image: product.image,
                id: product.id,
                type: product.type.title,
                link: product.link,
                variants: mappedVariants,
                attributes: attributesToDisplay,
            }
            modelVariants.push(mappedProduct)
        })
    }

    function updatePaginatedModels() {
        paginatedModels.value = filteredProducts.value.slice((currentPage.value - 1) * perPage.value, currentPage.value * perPage.value)
        modelCounts.value = filteredProducts.value.length
    }

    function applyFilters() {
        const filterStore = useFilterStore()
        filteredProducts.value = structuredClone(modelVariants)
        filterStore.filters.forEach((filter) => {
            if (filterStore.selectedFilters[filter.title]) {
                if (filter.title == i18n.global.t('filter.type.label')) {
                    filteredProducts.value = filteredProducts.value.filter(product => product.type === filterStore.selectedFilters[filter.title])
                    return
                }
                // iterate over attributes of variants in each product and if the attribute is there add the product with that variant to the filteredProducts
                filteredProducts.value = filteredProducts.value.filter(product => product.variants.some(variant => variant.attributes.some(attribute => attribute.title === filterStore.selectedFilters[filter.title])))

                // remove the those variants that doesnt have the selected attribute in their attributes
                filteredProducts.value.forEach((product) => {
                    if (filter.title == i18n.global.t('filter.type.label')) {
                        product.variants = product.variants.filter(variant => variant.type === filterStore.selectedFilters[filter.title])
                        return
                    }
                    product.variants = product.variants.filter(variant => variant.attributes.some(attribute => attribute.title === filterStore.selectedFilters[filter.title]))
                })
            }
        })
        useFilterStore().updateFilters()
        updatePaginatedModels()
    }

    return {
        products,
        filteredProducts,
        modelVariants,
        paginatedModels,
        totalModels,
        modelCounts,
        currentPage,
        perPage,
        loadModelsFromApi,
        updateModelList,
        updatePaginatedModels,
        applyFilters
    }
})
